module.exports = __webpack_public_path__ + "../dist/assets/fonts/symbols_89C3.woff";